import { callFunction } from "./functions-client";

// Group conversations (LOS Phase 6 — Messaging & Collaboration).
export interface Group {
  id: string;
  title: string;
  kind: string;
  last_message_at?: string;
  participant_count?: number;
}

export interface GroupParticipant {
  account_id: string;
  role: string;
  name: string | null;
}

export interface GroupMessage {
  id: string;
  sender_id: string;
  body: string;
  created_at: string;
  sender_name: string | null;
}

export const createGroup = (title: string, kind = "topic", member_account_ids: string[] = []) =>
  callFunction<{ group: Group }>("groupchat/create", { body: { title, kind, member_account_ids } });

export const listGroups = () =>
  callFunction<{ groups: Group[] }>("groupchat/list", { method: "GET" });

export const groupMessages = (group_id: string) =>
  callFunction<{ group: Group; participants: GroupParticipant[]; messages: GroupMessage[]; me: string }>(
    `groupchat/messages?group_id=${encodeURIComponent(group_id)}`,
    { method: "GET" },
  );

export const sendGroupMessage = (group_id: string, body: string) =>
  callFunction<{ message: GroupMessage }>("groupchat/send", { body: { group_id, body } });

export const addGroupMember = (group_id: string, account_id: string) =>
  callFunction<{ ok: boolean }>("groupchat/add", { body: { group_id, account_id } });

export const leaveGroup = (group_id: string) =>
  callFunction<{ ok: boolean }>("groupchat/leave", { body: { group_id } });
